import { Button } from "devextreme-react";
import CustomDialog from "../HOC/CustomComponents/CustomDialog";
import { Box, Collapse, Grid, Typography } from "@mui/material";
import ControlMUItextField from "../HOC/MUI/ControlMUItextField";
import MuiSwitch from "../HOC/MUI/MUIswitch";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { useForm } from "react-hook-form";
import { gql, useMutation, } from "@apollo/client";
import { SAVE_WARE_HOUSE_SECTION } from "./Graphql";

import { setValidationError } from "../HOC/CustomFunctions/setValidationError";




export const WarehouseSectionForm = ({
    open,
    handelCloseDialog,
    warehouseId,
    refetch,
    sections,

}) => {

    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const { handleSubmit, control, formState, setValue, setError } = useForm(
        { defaultValues: { active: true } }
    );
    const { errors } = formState;



    useEffect(() => {
        if (sections) {
            setValue("id", sections?.id);
            setValue("name", sections?.name);
            setValue("active", sections?.active);
        }
        return () => { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const [saveWareHouse] = useMutation(
        gql`
      ${SAVE_WARE_HOUSE_SECTION.query}
    `
    );

    const onSubmit = (data) => {
        for (const key in data) {
            if (data[key] === "" && key === "code") {
                delete data[key];
            }
            if (data[key] === "") {
                data[key] = null;
            }
        }
        saveWareHouse({
            variables: {
                input: {
                    warehouseId: warehouseId,
                    ...data,
                },
            },
        })
            .then((data) => {
                refetch()
                handelCloseDialog();
                enqueueSnackbar(t("saveSuccessful"), {
                    variant: "success",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "right",
                    },
                    TransitionComponent: Collapse,
                });
            })
            .catch(({ graphQLErrors }) => {
                if (graphQLErrors?.[0]?.extensions.category === "validation") {
                    setValidationError(graphQLErrors, setError);
                } else {
                    enqueueSnackbar(graphQLErrors[0].message, {
                        variant: "error",
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "right",
                        },
                        TransitionComponent: Collapse,
                    });
                }

                console.log(graphQLErrors);
            });
    };

    const body = (
        <Grid
            container
            justifyContent="flex-start"
            aligns="center"
            sx={{
                width: "100%",
                margin: 0,
                padding: 2,
            }}
            spacing={2}

        >

            <Grid xs={12} aligns="flex-start">
                <ControlMUItextField
                    control={control}
                    errors={errors}
                    name={"name"}
                    label={t("name")}
                    rules={{ required: t("fieldIsRequired") }}
                />
            </Grid>



        </Grid>

    );
    const title = (
        <Grid container justifyContent="space-between" alignItems={"center"} >
            <Typography variant="h6" color={"text.primary"}>
                {t("warehouseSection")}
            </Typography>
            <Box>
                <MuiSwitch
                    edge="end"
                    name="active"
                    label={t("active")}
                    control={control}
                />
            </Box>
        </Grid>
    );
    return (
        <>
            {open && (
                <CustomDialog
                    fullWidth
                    maxWidth="xs"
                    open={open}
                    onClose={handelCloseDialog}
                    title={title}
                    content={body}
                    actions={
                        <>
                            <Button onClick={handelCloseDialog}>{t("cancel")}</Button>
                            <Button onClick={handleSubmit(onSubmit)}>
                                {t("confirm")}
                            </Button>
                        </>
                    }
                ></CustomDialog>
            )}
        </>
    );
};
